import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
const REPORTS_BASE_URL = `${API_BASE_URL}/reports`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Token não encontrado. Faça login novamente.");
  }

  return { Authorization: `Bearer ${token}` };
};

export const getTransactionsReport = async (params = {}) => {
  const { data } = await axios.get(`${REPORTS_BASE_URL}/transactions`, {
    params,
    headers: getAuthHeaders(),
  });
  return data;
};

export const getCombinedTransactionsReport = async (params = {}) => {
  const { data } = await axios.get(`${REPORTS_BASE_URL}/combined`, {
    params,
    headers: getAuthHeaders(),
  });
  return data;
};

export const getSalesEventsSummary = async (params = {}) => {
  const { data } = await axios.get(`${REPORTS_BASE_URL}/sales-events-summary`, {
    params,
    headers: getAuthHeaders(),
  });
  return data;
};

export const getChargebackReport = async (paymentId) => {
  const { data } = await axios.get(
    `${REPORTS_BASE_URL}/chargeback/${encodeURIComponent(paymentId)}`,
    {
      headers: getAuthHeaders(),
    }
  );
  return data;
};

export const searchChargebackPayments = async (query) => {
  const { data } = await axios.get(`${REPORTS_BASE_URL}/chargeback-search`, {
    params: { q: query },
    headers: getAuthHeaders(),
  });
  return data;
};

export const getChargebackReportHtmlUrl = (paymentId) => {
  return `${REPORTS_BASE_URL}/chargeback/${encodeURIComponent(paymentId)}?format=html`;
};

export const getAuthToken = () => localStorage.getItem("token") || "";
